import P from '../components/texts/p/P';
import Icon from '../components/icon/Icon';
import { formatCuit, formatMoney } from './Masks';

export interface ProtectorRow {
  id: number;
  name: string;
  cuit: string;
  amount: number;
  integrated: number;
  percentage: number;
}

export function getProtectorColumns(handleRowClicked?: (row: ProtectorRow) => void) {
  return [
    {
      name: 'Documento',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {formatCuit(row.cuit || '')}
          </P>
        </div>
      ),
      minWidth: '140px',
      sortable: true,
      sortField: 'cuit',
    },
    {
      name: 'Razón social',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {row.name}
          </P>
        </div>
      ),
      minWidth: '200px',
      grow: 1,
    },
    {
      name: 'Aporte',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {formatMoney(row.amount)}
          </P>
        </div>
      ),
      minWidth: '160px',
      sortable: true,
      sortField: 'amount',
    },
    {
      name: 'Integrado',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {formatMoney(row.integrated)}
          </P>
        </div>
      ),
      minWidth: '160px',
      sortable: true,
      sortField: 'integrated',
    },
    {
      name: '% de aporte sobre el fondo integrado',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {`${row.percentage?.toFixed(2)} %`}
          </P>
        </div>
      ),
      minWidth: '220px',
    },
    {
      name: 'Acción',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%', display: 'flex', justifyContent: 'center' }}>
          <span style={{ pointerEvents: 'none' }}>
            <Icon name='arrow_right_outline' variant='info' width={24} height={24} />
          </span>
        </div>
      ),
      width: '90px',
      center: true,
    },
  ];
}


